import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Dropdown, { DropdownValue } from '../common/Form/Dropdown/Dropdown';

import { PAGE_CREATE_MODIFIER, PAGE_MENUS, PAGE_MODIFIERS } from '../../constants/UriConstants';
import AddItemButtons from '../AddItemButtons';
import PageHeader from '../PageHeader';
import { useRestaurantContext } from '../../contexts/RestaurantContext';

const MobileMenuTopBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { menus } = useRestaurantContext();
  const isMenuItemsView = pathname.includes(PAGE_MENUS) || pathname === '/';
  const isModifiersView = pathname.includes(PAGE_MODIFIERS);

  const [selectedDropdownOption, setSelectedDropdownOption] = useState<string | { value: string; label: string }>(
    isMenuItemsView ? PAGE_MENUS : PAGE_MODIFIERS
  );

  useEffect(() => {
    if (isMenuItemsView) {
      setSelectedDropdownOption(PAGE_MENUS);
    } else if (isModifiersView) {
      setSelectedDropdownOption(PAGE_MODIFIERS);
    }
  }, [isMenuItemsView, isModifiersView]);

  const dropdownOptions: DropdownValue[] = [
    { value: PAGE_MENUS, label: 'Menu Items' },
    { value: PAGE_MODIFIERS, label: 'Modifiers' }
  ];

  const handleSelectChange = (value: string | { value: string; label: string } | undefined) => {
    setSelectedDropdownOption(value);
    if (typeof value === 'string') {
      navigate(value);
    } else if (value) {
      navigate(value.value);
    }
  };

  const hasMenuSections = () => {
    let hasValues = false;

    menus.forEach((menu) => {
      if (menu?.menuSections?.length > 0) {
        hasValues = true;
      }
    });

    return hasValues;
  };

  return (
    <>
      <PageHeader title="MENUS">
        {hasMenuSections() && isMenuItemsView ? <AddItemButtons /> : null}
        {isModifiersView ? (
          <Link to={`/${PAGE_CREATE_MODIFIER}`} className="page-header__action-button mobile-add-modifier-button">
            ADD MODIFIER
          </Link>
        ) : null}
      </PageHeader>
      <div className="mobile-menu-top-bar-container">
        <Dropdown
          value={typeof selectedDropdownOption === 'string' ? selectedDropdownOption : ''}
          onChange={handleSelectChange}
          values={dropdownOptions}
          className="mobile-navbar-dropdown"
        />
      </div>
    </>
  );
};

export default MobileMenuTopBar;
